import {Component, OnInit, Input, EventEmitter, Output}        from '@angular/core';
import {DomSanitizationService} from '@angular/platform-browser';
declare var $: any;
import {RecargaCreditoService} from './recargaCredito.service';
import {ProvinciaService} from '../provincia/provincia.service';
import {PermisoService} from '../permiso/permiso.service';
import {NotificacionService} from '../notificacion/notificacion.service';
import {LoginService} from '../login/login.service';
import {RecargaCredito} from './recargaCredito';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'recargaCredito',
    template: require('../../app/recargaCredito/recargaCredito.component.html'),
    styles: [require('../../app/recargaCredito/recargaCredito.component.css')]
})
export class RecargaCreditoComponent implements OnInit {

    @Input() idEmpresa: string;
    @Input() recargasCredito: any;
    @Input() mensajesRecargasMes: number;
    @Input() getRecargasMensajes: Function;
    recargaCredito: RecargaCredito;
    modificoContacto;
    deshabilitar: boolean;
    @Output() permisos = new EventEmitter();
    active: any;

    constructor(private recargaCreditoService: RecargaCreditoService,
                private permisoService: PermisoService,
                private sanitizer: DomSanitizationService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Inicializar banderas para resetear forms
        this.active = true;

        //Inicializar recargaCredito
        this.recargaCredito = new RecargaCredito();
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;

        //Pedir permisos
        var resultadoPermisos = new Map();
        this.permisoService.getPermiso("recargaCredito").subscribe(permisos => {
            if (permisos.tipoPermiso)
                for (let permiso of permisos.tipoPermiso) {
                    resultadoPermisos.set(permiso.descripcion, true);
                }
            this.permisos.emit({permisos: resultadoPermisos});
            //Si no tiene permiso para ver redirijo
            if (!resultadoPermisos.get("read"))
                this.deshabilitar = true;
        });
    }

    ngOnDestroy() {
    }

    eliminar(idRecarga) {
        this.recargaCreditoService.delete(idRecarga).subscribe(recargaCredito => {
            setTimeout(() => $(document.body).addClass('modal-open'), 3000);
            setTimeout(() => $(document.body).addClass('modal-open'), 4000);
            this.getRecargasMensajes();
        })
    }

    save() {
        this.recargaCredito.empresa_id = this.idEmpresa;
        this.recargaCreditoService
            .save(this.recargaCredito)
            .subscribe((recargaCredito) => {
                //Inicializo variables
                this.recargaCredito = new RecargaCredito();
                //Reseteo formEmpresa para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                setTimeout(() => $(document.body).addClass('modal-open'), 3000);
                setTimeout(() => $(document.body).addClass('modal-open'), 4000);
                this.getRecargasMensajes();

            })
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/recargaCredito/recargaCredito.component.ts